import GenerateCertificate from './GenerateCertificate';
import type { GenerateCertificateProps } from './types';

export default GenerateCertificate;
export type { GenerateCertificateProps };
